import React, { useEffect, useRef, useState } from "react";
import "../../App.css";
import "./FormInput.css";
import Tooltip from "../Tooltip/Tooltip";
import { formatClassNames } from "../../helpers/util";


function FormInput({ id, unit, tooltip, register, value, key, fullWidth }) {
  const wrapperDivRef = useRef(null);
  const isDisabledInput = value != null || register == null;

  return (
    <div
      ref={wrapperDivRef}
      className={formatClassNames("form-input-wrapper", { text: !unit, fullWidth })} key={key}
    >
      {isDisabledInput ? (
        <div className="disabled-input">{value}</div>
      ) : (
          <input id={id} type={!unit ? "text" : "number"}
            {...register(id)}
          />
      )}
      {unit && <FormInputBadge unit={unit} tooltip={tooltip} wrapperDivRef={wrapperDivRef} />}
    </div>
  );
}

export default FormInput;


function FormInputBadge({ unit, tooltip, wrapperDivRef }) {
  
  var [moreToolTip, setMoreToolTip] = useState("");

  const badgeRef = useRef(null);
  useEffect(() => {
    const isEllipsisActive = () => {
      return (badgeRef.current.offsetWidth / wrapperDivRef.current.offsetWidth) > 0.5 ;
    };

    if (badgeRef.current != null && wrapperDivRef.current != null
      && isEllipsisActive()) {
      setMoreToolTip(<Tooltip icon="fas fa-info-circle" content={unit} direction="left" />);
    }
  }, [unit,  wrapperDivRef]);

  return (
    <span className="badge" ref={badgeRef}>
      {moreToolTip !== "" ? moreToolTip : unit} {tooltip && <Tooltip content={tooltip} />}
    </span>
  )
}
